import { STATUS_SCHEMA } from '../styles/theme';
import type { VisitStatus } from '../api/types';

export function StatusBadge({ status }: { status: VisitStatus }) {
  const s = STATUS_SCHEMA[status] ?? { bg: '#f1f5f9', color: '#64748b', label: status };
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 9px',
        borderRadius: 999,
        background: s.bg,
        color: s.color,
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {s.label}
    </span>
  );
}
